import { useDataChainId } from '@ui/hooks/datachain';
import { getUserAgent } from '@ui/utils/getUserAgent';
import { useEffect } from 'react';
import { useAccount, useChainId } from 'wagmi';

import { getBugsnagClient } from './bugsnag';

export const useBugsnagMeta = () => {
  const { address, connector } = useAccount();
  const walletChainId = useChainId();
  const dataChainId = useDataChainId();

  useEffect(() => {
    getBugsnagClient().then((c) => {
      c?.addMetadata('user', {
        wallet: address,
        walletChainId,
        dataChainId,
        platform: getUserAgent()?.platform,
        browser: getUserAgent()?.browser,
        connector: connector?.name,
      });
    });
  }, [address, connector?.name, dataChainId, walletChainId]);
};
